export default "__VITE_ASSET__573aa7cf__"